import { KeyboardVoiceOutlined } from '@mui/icons-material';
import { Link } from '@on3/ui-lib/components/Link';

import styles from './PodcastsButton.module.scss';

export const PodcastsButton = () => {
  return (
    <Link className={styles.component} href="/shows/">
      Podcasts and shows
      <KeyboardVoiceOutlined />
    </Link>
  );
};
